import { beginConnect } from "../../../api/externalConnectionsApi";

/**
 * Leave the web app for the provider's authorization page. The provider sends the browser to
 * `/connections/<provider>/callback`, which finishes the connection and comes back here.
 */
export async function connectAndReturnHere(provider: string): Promise<void> {
  const here = `${window.location.pathname}${window.location.search}`;
  window.location.assign(await beginConnect(provider, here));
}
